import React, { useEffect, useState } from 'react'
import { UlupinarContactProps, ContactFormResponseType } from './type'
import { useApp } from '@/core/contexts/app'
import { Column, Container, Row } from '@/components/base/gridview'
import Image from '@/components/base/image'
import query from '@/services/http/wap/query'
import { classnames } from 'begonya/functions'

const UlupinarContact: React.FunctionComponent<UlupinarContactProps> = ({
  contactimage,
  location,
  phone,
  inputimage,
  faks,
}) => {
  const app = useApp()
  const [formStatus, setFormStatus] =
    useState<ContactFormResponseType>('default')
  const [loadingState, setloadingState] = useState(false)
  const [formValues, setFormValues] = useState<any>({})
  useEffect(() => {
    formStatus && setloadingState(false)

    // formValues.map((input) => (input.value = ''))
  }, [formStatus])

  const onSubmit = (e: any) => {
    e.preventDefault()
    setloadingState(true)

    const formDataArray = [
      {
        name: 'ePosta',
        data: {
          refs: [],
          value: formValues.email,
        },
      },
      {
        name: 'soyisim',
        data: {
          refs: [],
          value: formValues.surname,
        },
      },
      {
        name: 'iSim',
        data: {
          refs: [],
          value: formValues.name,
        },
      },
      {
        name: 'baslik',
        data: {
          refs: [],
          value: formValues.name + ' ' + formValues.surname,
        },
      },
      {
        name: 'message',
        data: {
          refs: [],
          value: formValues.message,
        },
      },
    ]

    const requestBody = {
      parameters: null,
      columns: formDataArray,
    }

    query
      .runForm<{ id: string }>(
        app.environment,
        {
          name: 'iletisim-formu-create-veri-sorgusu-2',
          language: app.language,
        },
        requestBody
      )
      .then((response) => {
        if (response.data.id) {
          setFormStatus('success')
          setTimeout(() => {
            setFormStatus('default')
            setFormValues({
              name: '',
              surname: '',
              email: '',
              message: '',
            })
          }, 2000)
        }
        setloadingState(false)
      })

      .catch(() => {
        setFormStatus('error')
        setTimeout(() => setFormStatus('default'), 2000)
        setloadingState(false)
      })
  }

  return (
    <div className="ulupinar-contact">
      <div className="ulupinar-contact-main">
        <div className="ulupinar-contact-main-page">
          <div className="ulupinar-contact-main-page-items">
            <Container size="medium">
              <Row>
                <Column
                  xs={{ size: 12 }}
                  sm={{ size: 12 }}
                  md={{ size: 12 }}
                  lg={{ size: 12 }}
                  xl={{ size: 12 }}
                >
                  <div className="ulupinar-contact-image">
                    <figure>
                      <Image className="full-image" {...contactimage} alt="" />
                    </figure>
                  </div>
                </Column>
              </Row>
              <Row>
                <Column
                  xs={{ size: 12 }}
                  sm={{ size: 12 }}
                  md={{ size: 12 }}
                  lg={{ size: 12 }}
                  xl={{ size: 12 }}
                >
                  <div className="ulupinar-contact-main-page-items-info">
                    <div className="ulupinar-contact-location">
                      <p>{app.settings.translations['address']}</p>
                      {location}
                    </div>
                    <div className="ulupinar-contact-phone">
                      <p>{app.settings.translations['phone']}</p>
                      {phone}
                    </div>
                    <div className="ulupinar-contact-faks">
                      <p>{app.settings.translations['faks']}</p>
                      {faks}
                    </div>
                  </div>
                </Column>
              </Row>
            </Container>
          </div>

          <form onSubmit={onSubmit} className="ulupinar-contact-input">
            <Container size="medium">
              <Row>
                <Column
                  xs={{ size: 12 }}
                  sm={{ size: 12 }}
                  md={{ size: 12 }}
                  lg={{ size: 8 }}
                  xl={{ size: 8 }}
                >
                  <div className="direction">
                    <div className="ulupinar-contact-input-withus">
                      <h2>{app.settings.translations['contact-withus']}</h2>
                    </div>
                    <div className="ulupinar-contact-input-contact-fill">
                      <p style={{ fontWeight: '400' }}>
                        {app.settings.translations['fill']}
                      </p>
                    </div>
                    <input
                      required
                      type="text"
                      name="name"
                      placeholder={app.settings.translations['name']}
                      onChange={(e) => {
                        setFormValues({ ...formValues, name: e.target.value })
                      }}
                    />
                    <input
                      required
                      type="text"
                      name="surname"
                      placeholder={app.settings.translations['surname']}
                      onChange={(e) => {
                        setFormValues({
                          ...formValues,
                          surname: e.target.value,
                        })
                      }}
                    />
                    <input
                      required
                      type="email"
                      name="email"
                      placeholder={app.settings.translations['email-address']}
                      onChange={(e) => {
                        setFormValues({ ...formValues, email: e.target.value })
                      }}
                    />
                    <textarea
                      required
                      placeholder={
                        app.settings.translations['message-placeholder']
                      }
                      onChange={(e) => {
                        setFormValues({
                          ...formValues,
                          message: e.target.value,
                        })
                      }}
                    />
                    <div
                      className={classnames(
                        'alert-message',
                        formStatus === 'success'
                          ? 'alert-message--success alert-message--active'
                          : '',
                        formStatus === 'error'
                          ? 'alert-message--error alert-message--active'
                          : ''
                      )}
                    >
                      {(() => {
                        switch (formStatus) {
                          case 'success':
                            return app.settings.translations['success.message']
                          case 'error':
                            return app.settings.translations['error.message']
                          default:
                            return null
                        }
                      })()}
                    </div>
                    <button className="submit" type="submit">
                      {app.settings.translations['send']}
                    </button>
                  </div>
                </Column>
                <Column
                  xs={{ size: 12 }}
                  sm={{ size: 12 }}
                  md={{ size: 12 }}
                  lg={{ size: 4 }}
                  xl={{ size: 4 }}
                >
                  <div className="ulupinar-input-image">
                    <figure>
                      <Image {...inputimage} alt="" />
                    </figure>
                  </div>
                </Column>
              </Row>
            </Container>
          </form>
        </div>
      </div>
    </div>
  )
}

export default UlupinarContact
